<div class="car_inquiry">
  <div class="inquiry_box flex_layout">
    <a href="{{ appUrl }}/inquiry?car_id={{ car.id }}" class="inquirybtn btn_mail">
      <div class="inquiry_icon"><img src="assets/img/inquiry_mail.png" width="40" alt=""></div>
      <div class="inquiry_label">{{ lang | i18nSelect: strings.carDetail.inquiryButtonLabel }}</div>
    </a>
  </div>
</div>
